import * as React from 'react'
import { FieldErrors } from 'react-hook-form/dist/types/errors'
import { cls } from '../../utils/utils'
import { defaultMaxLength, defaultPattern, FIELDS_VALIDATION } from '../Dialog/constants'
import { FormFields } from '../Dialog/Dialog.types'
import { ITextInput } from './TextInput.types'
import styles from './TextInput.module.scss'
import PhoneInputTemplate from './components/PhoneInput'

const getInputErrorStyle = (inputName: string, errors: any) => {
  return errors && errors[inputName] && styles.inputInvalid
}

const renderInvalidMessage = (name: keyof FormFields, text: string, errors?: FieldErrors<FormFields>) => {
    let message: string | undefined
    if (errors === undefined) {
      return null
    }

    if (errors[name]?.type === 'manual') {
      message = errors[name]?.message
    }

    switch (errors[name]?.type) {
      case 'required':
        message = `${text} cannot be empty.`
        break
      case 'maxLength':
        message = `${text} is invalid.`
        break
      case 'pattern':
        message = `${text} is invalid.`
        break
      case 'validate':
        message = errors[name]?.message
        break
    }
    return <p className={cls('text--button', styles.message)}>{message}</p>
}

const TextInput: React.FC<ITextInput> = ({
  name,
  text,
  register,
  className,
  type,
  pattern,
  maxLength,
  errors,
  readOnlyLabel,
  disabled = false,
  readOnly = false,
  optional = false,
  control,
  getFieldState,
  formState,
}) => {
  const registeredData =
    register &&
    register(name, {
      required: !optional,
      maxLength: maxLength || defaultMaxLength,
      pattern: pattern || defaultPattern,
      validate: (value: string) =>
        !optional &&
        (typeof type === 'string' ? FIELDS_VALIDATION[type as keyof typeof FIELDS_VALIDATION] : FIELDS_VALIDATION.default)(value, text),
    })

  return (
    <>
      <div className={cls(className, styles.inputContainer)}>
        {name === 'phone' ? (
          <PhoneInputTemplate
            name={name}
            errors={errors}
            control={control}
            getFieldState={getFieldState}
            formState={formState}
          />
        ) : (
          <>
            {!disabled && !readOnly ? (
              <>
                <input
                  type={'text'}
                  id={name}
                  {...registeredData}
                  onInput={(e) => {
                    const target = e.target as HTMLInputElement
                    if (target.value.length > (maxLength || defaultMaxLength))
                      target.value = target.value.slice(0, maxLength || defaultMaxLength)
                  }}
                  maxLength={maxLength || defaultMaxLength}
                  className={cls('text--small', styles.input, getInputErrorStyle(name, errors))}
                  required
                  placeholder={text}
                />
              </>
            ) : (
              <>
                <input
                  type={'text'}
                  id={name}
                  {...registeredData}
                  maxLength={maxLength || defaultMaxLength}
                  className={cls('text--small', styles.input, styles.disabledReadonly, disabled && styles.disabled)}
                  required
                  readOnly={readOnly}
                  disabled={disabled}
                  value={text}
                />
                {readOnlyLabel && (
                  <label htmlFor={name} className={cls('text--button', styles.labelReadOnly)}>
                    {readOnlyLabel}
                  </label>
                )}
              </>
            )}
            {renderInvalidMessage(name, text, errors)}
          </>
        )}
      </div>
    </>
  )
}

export default TextInput
